import { Skeleton } from 'antd'
import Styles from './LoadingSkeleton.module.scss'
import { Tabs } from '../Tabs/Tabs'
import { Item } from '@react-stately/collections'
import { BarChart } from 'blaze-ui/icons'
import AnalyticsStyles from '../../Analytics.module.scss'
import { noop } from 'lodash'
import { SummaryItem } from 'screens/Analytics/Summary/SummaryItem'
import PostNow from 'blaze-ui/icons/32/PostNow'
import { HighDetailedClockPlus } from 'blaze-ui/icons/20/HighDetailedClockPlus'
import { HighDetailedFollowers } from 'blaze-ui/icons/20/HighDetailedFollowers'

const SummarySkeleton = () => (
  <div className={Styles.sectionSkeleton}>
    <Skeleton className={Styles.header} title paragraph={false} />
    <div className={Styles.summary}>
      <SummaryItem
        isFetching
        name="Total Posts"
        data={{ current_period: null, previous_period: null }}
        icon={<PostNow size={46} />}
      />
      <div className={Styles.divider} />
      <SummaryItem
        isFetching
        name="Hours Saved"
        data={{ current_period: null, previous_period: null }}
        icon={<HighDetailedClockPlus size={46} />}
      />
      <div className={Styles.divider} />
      <SummaryItem
        isFetching
        name="Followers"
        data={{ current_period: null, previous_period: null }}
        icon={<HighDetailedFollowers size={46} />}
      />
    </div>
  </div>
)

const MetricSkeleton = () => (
  <div className={Styles.sectionSkeleton}>
    <Skeleton className={Styles.header} title paragraph={false} />
    <div className={Styles.metric}>
      <Skeleton className={Styles.metricName} title paragraph={false} />

      <Skeleton className={Styles.lineChart} title paragraph={false} />
    </div>
  </div>
)

export const LoadingSkeleton = () => (
  <div className={AnalyticsStyles.content}>
    <Tabs aria-label="Instagram Analytics Tabs" selectedKey={'overview'} onSelectionChange={noop}>
      <Item
        key="overview"
        title={
          <div className={Styles.tabTitle}>
            <BarChart />
            Overview
          </div>
        }
      >
        <div className={Styles.container}>
          <SummarySkeleton />
          <MetricSkeleton />
          <MetricSkeleton />
        </div>
      </Item>
    </Tabs>
  </div>
)
